import { usePermissionStore } from "controller/store/PermissionStore";
import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import { ReactNode } from "react";

export const ModuleWrapper = ({
  children,
  module,
}: {
  module: "SD" | "CC" | "BL" | "RPT" | "CUSTOMER";
  children: ReactNode;
}) => {
  const havePermission = usePermissionStore((state) =>
    state.isModulePermitted(module),
  );

  return <>{havePermission ? children : <UnautherizedScreen />}</>;
};
